/**
 * Refused recipient codes after which the parcel is returned to the sender. The reservation API owns and
 * enforces the limit, and every answer from the gateway carries the resulting count - so this is only
 * used to write "of 3" and to say how much room is left. The remaining mirror: the limit would have to
 * come from the reservation API through the gateway to disappear entirely, which the counter needs before
 * any call is made.
 */
export const MAX_TWO_FACTOR_ATTEMPTS = 3;

export const remainingTwoFactorAttempts = (failedAttempts: number) =>
  Math.max(0, MAX_TWO_FACTOR_ATTEMPTS - failedAttempts);

/** Escalates with the stakes: calm while there is room, warning on the last attempt, error once the parcel is gone. */
export const twoFactorAttemptsAlertType = (remainingAttempts: number) =>
  remainingAttempts === 0
    ? 'error'
    : remainingAttempts === 1
      ? 'warning'
      : 'success';
